<div>
  <div class="product-overview">
    <div class="product-id">
      <va-icon [iconUrl]="iconUrl" [iconName]="title" [diameter]="75"></va-icon>

      <div class="product-id-text">
        <mat-card-title
          [ngClass]="{
            'stencil-title stencil-shimmer': !title,
          }"
        >
          {{ title }}
        </mat-card-title>

        <mat-card-subtitle
          [ngClass]="{
            'stencil-tagline stencil-shimmer': !title && !tagline,
            tagline: tagline
          }"
        >
          {{ tagline }}
        </mat-card-subtitle>

        <div *ngIf="prerequisite" class="prerequisite">
          <span class="requires-text">
            {{ 'FRONTEND.STORE.REQUIRES' | translate }}
          </span>
          <span>{{ prerequisite }}</span>
        </div>

        <mat-chip-listbox *ngIf="!this.hideTags">
          <mat-chip-option *ngFor="let chip of chipLabels">
            {{ chip | translate }}
          </mat-chip-option>
        </mat-chip-listbox>
      </div>
    </div>

    <div class="pricing">
      <button
        *ngIf="showAction && !showEnableAddon"
        mat-raised-button
        class="app-enable-button"
        [disabled]="!actionEnabled"
        (click)="onActionSelected()"
      >
        {{ actionLabel }}
      </button>

      <button mat-stroked-button class="contact-button" *ngIf="!actionEnabled" (click)="handleContactActionClick()">
        {{ 'FRONTEND.STORE.CONTACT_US' | translate }}
      </button>

      <button
        *ngIf="showEnableAddon && !showAction"
        mat-flat-button
        class="app-enable-button"
        [disabled]="!showEnableAddon"
        (click)="onActionSelected()"
      >
        {{ actionLabel }}
      </button>

      <div *ngIf="prerequisiteLabel && !showEnableAddon" class="addon-enable" (click)="onPrerequisiteSelected()">
        {{ 'FRONTEND.STORE.ENABLED_WITH_PREREQUISITE' | translate : { prerequisite: prerequisiteLabel } }}
      </div>

      <div *ngIf="showPricing" class="price-box">
        <billing-ui-price-display
          *ngIf="appPrice"
          [appPrice]="appPrice"
          [form]="'verbose'"
          [currencyCode]="partnerCurrency"
          [size]="'large'"
        ></billing-ui-price-display>
      </div>

      <p *ngIf="pricingActionEnabled" class="pricing-action-container">
        <a (click)="primaryPricingActionSelected.emit()">
          {{ primaryPricingActionLabel }}
        </a>
        <a (click)="pricingActionSelected.emit()">{{ pricingActionLabel }}</a>
      </p>
    </div>
  </div>
</div>
